import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const Listado = WithErrorBoundary(
  'Perfiles',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./Listado')),
)

const NuevoPerfil = WithErrorBoundary(
  'Perfiles',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./NuevoPerfil')),
)

const EditarPerfil = WithErrorBoundary(
  'Perfiles',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./EditarPerfil')),
)

const DuplicarPerfil = WithErrorBoundary(
  'Perfiles',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./DuplicarPerfil')),
)

export default {
  path: 'perfiles',
  name: 'Perfiles',
  childRoutes: [
    { path: '', name: 'Listado', component: Listado, isIndex: true },
    { path: 'nuevo-perfil', name: 'Nuevo perfil', component: NuevoPerfil },
    { path: 'editar/:id', name: 'Editar perfil', component: EditarPerfil },
    { path: 'duplicar', name: 'Duplicar perfil', component: DuplicarPerfil },
  ],
};
